<template>
    <v-chip
    small
    label
    class="chips pl-2 pr-2"
    :color="ChipsColor"
    :dark="ChipsColor === 'black'"
    :style="{ color: chipTextColor }">
    {{ chipText }}
    </v-chip>
</template>

<script>
export default {
name: 'Chips',
    props: {
        chipText: {
        type: String,
        default: 'Chips'
        },
        ChipsColor: {
        type: String,
        default: 'Black'
        },
        chipTextColor: {
        type: String,
        default: 'Black'
        },
    },
};
</script>

<style scoped>

</style>
